// @flow
import jwtDecode from 'jwt-decode';
import Bugsnag from '@bugsnag/js';
import { createActions, handleActions } from 'redux-actions';

import { loadSharedData } from './shared';

import { setAuthToken } from '../../shared/utils';

const actions = createActions({
    AUTHENTICATION: {
        AUTHENTICATING: undefined,
        AUTHENTICATED: ({ token, user }) => ({ token, user }),
        LOGOUT: undefined,
        // REFRESH_TOKEN: ({ token, user }) => ({ token, user }),
    },
});

const initialState = {
    token: null,
    user: null,
    authenticated: false,
    authenticating: false,
    refreshingToken: false,
    error: false,
};

export default handleActions(
    {
        [actions.authentication.authenticating]: (state, action) =>
            Object.assign({}, state, {
                authenticating: true,
            }),

        [actions.authentication.authenticated]: {
            next: (state, action) => {
                const { token, user } = action.payload;

                return Object.assign({}, state, {
                    token,
                    user,
                    authenticating: false,
                    authenticated: true,
                });
            },
            throw: (state, action) =>
                Object.assign({}, initialState, {
                    error: true,
                }),
        },

        [actions.authentication.logout]: (state, action) =>
            Object.assign({}, initialState),
    },
    initialState
);

export const login = (email: string, password: string) => {
    return (dispatch: Function, getState: Function, api: Function) => {
        dispatch(actions.authentication.authenticating());

        return api
            .post('/auth/token', {
                email,
                password,
            })
            .then(response => {
                const token = response.data.token;
                const user = jwtDecode(token);

                setAuthToken(token);

                if (Bugsnag.isStarted()) {
                    Bugsnag.setUser(user.sub, email, user.userForenames);
                }

                dispatch(actions.authentication.authenticated({ token, user }));
                dispatch(loadSharedData());
            })
            .catch(err => {
                dispatch(actions.authentication.authenticated(err));
            });
    };
};

export const loginWithLocalStorageToken = (existingToken: string) => {
    return (dispatch: Function, getState: Function, api: Function) => {
        dispatch(actions.authentication.authenticating());

        const user = jwtDecode(existingToken);

        setAuthToken(existingToken);

        if (Bugsnag.isStarted()) {
            Bugsnag.setUser(user.sub, null, user.userForenames);
        }

        dispatch(
            actions.authentication.authenticated({ token: existingToken, user })
        );
        dispatch(loadSharedData());
    };
};

export const logout = () => {
    return (dispatch: Function, getState: Function, api: Function) => {
        setAuthToken('');
        if (Bugsnag.isStarted()) {
            Bugsnag.setUser(null, null, null);
        }
        dispatch(actions.authentication.logout());
        window.location.href = '/';
    };
};



// WEBPACK FOOTER //
// ./src/redux/reducers/authentication.js